import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-accessoagliatti-view',
  templateUrl: './form-accessoagliatti-view.component.html',
  styleUrls: ['./form-accessoagliatti-view.component.css']
})
export class FormAccessoagliattiViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
